import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Col, Row } from "reactstrap";
import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/Layout/PageTitle";
import useDynamicComponent from "../../components/dynamics/useDynamicComponent";
import { useIntl, FormattedMessage } from "react-intl";
import ButtonComponent from "../../components/ButtonComponent";
import InputComponent from "../../components/InputComponent";
import { DeliveryNoteEditDTO } from "../../models/DeliveryNote/DeliveryNoteEditDTO";
import { DeliveryNoteService } from "../../services/DeliveryNoteService";
import Toast from "../../helpers/Toast";

export default function DeliveryNoteEdit() {
  const [pageTitle, setPageTitle] = useState("Guia de Transporte");

  const { id } = useParams<{ id: string }>();
  const intl = useIntl();
  const navigate = useNavigate();

  const [loadingUpdate, setLoadingUpdate] = useState<boolean>(false);
  const [deliveryNote, setDeliveryNote] = useState<DeliveryNoteEditDTO>(
    {} as DeliveryNoteEditDTO
  );

  const deliveryNoteService = new DeliveryNoteService();

  useEffect(() => {
    getDeliveryNote();
  }, []);
  const getDeliveryNote = async () => {
    var response = await deliveryNoteService.GetById(String(id));

    if (response.success === false || response.obj == null) {
      Toast.Show("error", response.message);
      return;
    }

    setDeliveryNote(response.obj);
  };

  useEffect(() => {
    if (deliveryNote?.Id !== undefined) {
      setPageTitle(`Equipamento ${deliveryNote?.Id}`);
    }
  }, [setPageTitle, deliveryNote]);

  const editDeliveryNote = async () => {
    const updatedDeliveryNote: DeliveryNoteEditDTO = {
      Id: Number(id),
      atCode: deliveryNote.atCode,
      description: deliveryNote.description,
      deliveryAddress: deliveryNote.deliveryAddress,
      shippingAddress: deliveryNote.shippingAddress,
    };

    setLoadingUpdate(true);
    const response = await deliveryNoteService.EditDeliveryNote(
      updatedDeliveryNote
    );
    setLoadingUpdate(false);

    if (response.success !== true) {
      Toast.Show("error", response.message);
      return;
    }
    Toast.Show("success", response.message);
  };

  return (
    <Layout>
      <div className="pageContainer">
        <div className="pageHeader">
          <PageTitle
            title={intl.formatMessage({
              id: "Screens.DeliveryNotes.Create.Title",
            })}
            allowGoBack={true}
          />
        </div>
        <div className="pageBody">
          <Row>
            <Col xl={6} lg={6} md={6} sm={12} xs={12}>
              <>
                <Row style={{ margin: "0px", padding: "0px" }}>
                  <label style={{ margin: "0px", padding: "13px" }}>
                    <b>
                      <FormattedMessage id="Screens.DeliveryNotesEdit.SubTitle" />
                    </b>
                  </label>
                  <Col style={{ marginBottom: "10px" }}>
                    <InputComponent
                      xl={3}
                      lg={6}
                      md={11}
                      sm={12}
                      xs={12}
                      style={{ width: "100%" }}
                      type={"text"}
                      value={deliveryNote.atCode!}
                      label={intl.formatMessage({
                        id: "Screens.DeliveryNotesEdit.Info.ATCode",
                      })}
                      readOnly={false}
                      onChange={(t: string) => {
                        setDeliveryNote({ ...deliveryNote!, atCode: t });
                      }}
                    />

                    <InputComponent
                      xl={12}
                      lg={6}
                      md={11}
                      sm={12}
                      xs={12}
                      style={{ width: "100%" }}
                      type={"text"}
                      value={deliveryNote.description!}
                      label={intl.formatMessage({
                        id: "Screens.DeliveryNotesEdit.Info.Discription",
                      })}
                      readOnly={false}
                      onChange={(t: string) => {
                        setDeliveryNote({ ...deliveryNote!, description: t });
                      }}
                    />

                    <InputComponent
                      xl={12}
                      lg={6}
                      md={11}
                      sm={12}
                      xs={12}
                      style={{ width: "100%" }}
                      type={"text"}
                      value={deliveryNote.shippingAddress!}
                      label={intl.formatMessage({
                        id: "Screens.DeliveryNotesEdit.Info.ShippingAddress",
                      })}
                      readOnly={false}
                      onChange={(t: string) => {
                        setDeliveryNote({
                          ...deliveryNote!,
                          shippingAddress: t,
                        });
                      }}
                    />

                    <InputComponent
                      xl={12}
                      lg={6}
                      md={11}
                      sm={12}
                      xs={12}
                      style={{ width: "100%" }}
                      type={"text"}
                      value={deliveryNote.deliveryAddress!}
                      label={intl.formatMessage({
                        id: "Screens.DeliveryNotesEdit.Info.DeliveryAddress",
                      })}
                      readOnly={false}
                      onChange={(t: string) => {
                        setDeliveryNote({
                          ...deliveryNote!,
                          deliveryAddress: t,
                        });
                      }}
                    />
                  </Col>
                </Row>

                <Row style={{ marginTop: "10px", padding: "13px" }}>
                  <Col xl={2} lg={4} md={6} sm={6} xs={6}>
                    <ButtonComponent
                      disabled={loadingUpdate}
                      loading={loadingUpdate}
                      text={intl.formatMessage({ id: "EquipmentEditA.Save" })}
                      onClick={editDeliveryNote}
                      style={{ width: "100%" }}
                    />
                  </Col>
                </Row>
              </>
            </Col>
          </Row>
        </div>
      </div>
    </Layout>
  );
}
